<template>
  <div>
    <div id="applicants-declare">
      <div class="claims-process">
        <div class="header">理赔流程</div>
        <div class="content">
          <ul>
            <li>
              <div class="left">
                <div class="number">01</div>
                <div class="icon">
                  <img src="../../static/img/step.png" alt="step" />
                </div>
              </div>
              <div class="right">
                <div class="title">报案</div>
                <p>
                  您可通过如下方式报案： <br />
                  ①
                  您可以在微信搜索“保单微服务”，关注服务公众号，通过【叮咚理赔】提交报案。<br />
                  ② 电话报案：请您致电400-678-8169进行报案
                </p>
              </div>
            </li>
            <li>
              <div class="left">
                <div class="number">02</div>
                <div class="icon">
                  <img src="../../static/img/step.png" alt="step" />
                </div>
              </div>
              <div class="right">
                <div class="title">提交理赔资料</div>
                <p>
                  报案后，我们将会给您发送索赔指引邮件，告知您资料要求、理赔流程及纸质材料的寄送地址。<br />
                  如您不确定现有材料是否符合理赔要求，您可以将所有材料拍照或扫描并发送至claim@huize.com邮箱，我们将会协助您进行影像件预审核。
                </p>
              </div>
            </li>
            <li>
              <div class="left">
                <div class="number">03</div>
                <div class="icon">
                  <img src="../../static/img/step.png" alt="step" />
                </div>
              </div>
              <div class="right">
                <div class="title">理赔资料审核</div>
                <p>
                  事故责任明确、理赔资料齐全的案件，审核周期为：叮咚闪赔一般为3个工作日，普通类一般为5-7个工作日，重大类一般为20-22个工作日。
                </p>
              </div>
            </li>
            <li>
              <div class="left">
                <div class="number">04</div>
                <div class="icon">
                  <img src="../../static/img/step.png" alt="step" />
                </div>
              </div>
              <div class="right">
                <div class="title">领取赔款</div>
                <p>
                  理赔款一般在结案后的1-2个工作日可以到账。为保障到账时效，建议在提交理赔资料时以工、农、中、建、交或邮储等银行卡作为收款账户。
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="claims-notice">
        <div class="header">理赔须知</div>
        <div class="content">
          <ul>
            <li>
              <div class="count">1.</div>
              <div class="desc">
                如需报案或理赔协助服务，请拨打全国服务电话：400-678-8169。
              </div>
            </li>
            <li>
              <div class="count">2.</div>
              <div class="desc">
                报案时，请您提供保单号(或有效证件号码)、出险人姓名、出险时间、出险地点、出险原因、治疗就医情况等基本信息。
              </div>
            </li>
            <li>
              <div class="count">3.</div>
              <div class="desc">
                您报案后，我们将会给您发送索赔指引邮件，告知您资料要求和理赔流程。
              </div>
            </li>
            <li>
              <div class="count">4.</div>
              <div class="desc">
                发生合同约定保险事故需要到医院接受治疗，请到合同约定的医院（一般是二级或二级以上公立医院）进行就诊治疗。并请提醒主治医生使用医保范围内用药、诊疗项目及服务设施。就诊的同时请妥善保存病历（包含首诊病历）、原始收费凭证、处方、诊断证明、检查化验报告、住院证明等就医相关材料，以便向保险公司办理索赔申请。
              </div>
            </li>
            <li>
              <div class="count">5.</div>
              <div class="desc">
                一对一理赔协助：我们将全程协助您报案、告知您在当地如何处理、告知索赔所需相关证明资料、并监督保险公司理赔结案和协助催付赔款等。
              </div>
            </li>
            <li>
              <div class="count">6.</div>
              <div class="desc">
                领款方式：通过银行转账的方式，保险公司将通过财务系统直接向您所指定的银行账户进行转账支付。需要您提供开户银行、户名、账号等信息，建议您选择工农中建交或邮储，以便保险公司快速处理。
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="claims-tel">
      <div class="content">
        <div class="left">
          <img src="../../static/img/service-tel@2x.png" alt="tel" />
        </div>
        <div class="right">
          <div class="title">保险客服热线</div>
          <a class="tel" href="tel: 400-678-8169">400-678-8169</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';

export default {
  name: 'applicantsDeclare',
  created() {
    utils.setTitle('理赔流程');
  },
};
</script>

<style lang="less" scoped>
#applicants-declare {
  padding: 0.15rem;
  background-color: #fff;
  .header {
    position: relative;
    font-size: 0.16rem;
    color: #444;
    font-weight: 600;
    &::before {
      content: '';
      position: absolute;
      left: -0.11rem;
      top: -0.01rem;
      width: 0.03rem;
      height: 0.17rem;
      background-color: #ff5a60;
      border-radius: 3px;
    }
  }
  .claims-process {
    padding: 0.1rem 0 0 0.11rem;
    .content {
      ul {
        position: relative;
        overflow: hidden;
        &::before {
          content: '';
          position: absolute;
          left: 0.35rem;
          top: 0.2rem;
          width: 1px;
          z-index: 0;
          height: 81%;
          background-color: #ffacaf;
        }
        li {
          display: flex;
          align-items: flex-start;
          margin-top: 0.15rem;
          .left {
            display: flex;
            width: 0.46rem;
            align-items: center;
            .number {
              font-size: 0.16rem;
              line-height: 0.16rem;
              line-height: 0.2rem;
              color: #ff5a60;
              float: left;
              width: 0.25rem;
            }
            .icon {
              width: 0.2rem;
              height: 0.2rem;
              flex: 1;
              img {
                max-width: 100%;
                position: relative;
              }
            }
          }
          .right {
            flex: 1;
            padding-left: 0.1rem;
            .title {
              font-size: 0.15rem;
              line-height: 0.2rem;
              color: #444;
            }
            p {
              margin-top: 0.08rem;
              font-size: 0.14rem;
              color: #6f6f6f;
              line-height: 0.22rem;
            }
          }
        }
      }
    }
  }
  .claims-notice {
    padding: 0.3rem 0 0 0.11rem;
    .content {
      ul {
        li {
          font-size: 0.14rem;
          line-height: 0.19rem;
          display: flex;
          margin-top: 0.15rem;
          .count {
            width: 0.175rem;
            line-height: 0.22rem;
          }
          .desc {
            flex: 1;
            line-height: 0.22rem;
            color: #444;
          }
        }
      }
    }
  }
}
.claims-tel {
  height: 1.175rem;
  background-color: #f3f4f6;
  margin-top: 0.15rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    height: 0.35rem;
    display: flex;
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 0.35rem;
      img {
        max-width: 100%;
      }
    }
    .right {
      flex: 1;
      margin-left: 0.075rem;
      .title {
        font-size: 0.12rem;
        line-height: 0.12rem;
        color: #6f6f6f;
      }
      .tel {
        font-size: 0.16rem;
        line-height: 0.16rem;
        color: #444;
        margin-top: 0.08rem;
        display: block;
      }
    }
  }
}
</style>
